import React from 'react';
import WCopyrightREA from '../TEstateA/WCopyrightREA';
import { WButtonsREB } from './WButtonsREB';
import { WUserInfoREB } from './WUserInfoREB';

function TRealEstateB() {
  return (
    <>
      <WUserInfoREB />
      <WButtonsREB />
      <WCopyrightREA />
    </>
  );
}

export default TRealEstateB;
